module.exports = __webpack_public_path__ + "static/TriVidHorizontal-987c8d74441fbff7411d3d4bc5ee0303.mp4";